import React from 'react'
import Hero from '../Hero/Hero'
import Popular from '../Popular/Popular'
import Offers from '../Offers/Offers'
import NewCollection from '../NewCollections/NewCollections'
import NewsLetter from '../NewsLetter/NewsLetter'



export const Shop = () => {
  return (
    <div>
     <Hero/> 
     <Popular/>
     <Offers/>
     <NewCollection/>
      <NewsLetter/>
      
    </div>
  )
}
export default Shop